import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
type Typedeclare = string | string[] | Set<string>;
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule]
})
export class ButtonComponent {
  @Input() title !: string;
  @Input() buttonClass !: Typedeclare;
  @Input() isIconVisible: boolean = false;
  @Input() isTitleVisible: boolean = false;
  @Input() buttonType: string = 'button';
  @Input() buttonDisabled!: boolean;
  @Input() iconEleClass!: Typedeclare;
  @Input() buttonRole: string = "button";
  @Input() titleEleClass!: Typedeclare;
  @Input() buttonId: any;


  @Output() functionEmitter = new EventEmitter<string>();

  customFunctiionName() {
    this.functionEmitter.emit();
  }


}

